<script setup>
import { computed, onMounted, getCurrentInstance, onUnmounted, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SiderMenu from './components/SiderMenu.vue'
import HeaderNav from './components/HeaderNav.vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { socket_connect, socket_connect_without_login } from '@/api/index'

dayjs.locale('zh-cn')
const locale = zhCN

const route = useRoute()
const router = useRouter()
const { proxy } = getCurrentInstance();
const $socket = proxy.$socket;
const hideNavArr = ['Login', 'Scoreborad']

// 判断是否为登录页
const isLoginPage = computed(() => hideNavArr.includes(route.name))
onMounted(async() => {
  await router.isReady();
  console.log('当前路由名称:', route, route.name)
  localStorage.removeItem('subscribed_channel'); // 清除之前存储的频道列表
  if (route.name === 'Scoreborad') {
    socket_connect_without_login().then(async res => {
      // 初始化
      $socket.init({
        app_key: res.app_key,
        serverUrl: new URL(res.server_url)
      });

      // 连接socket
      await $socket.connect().then(res => {
        proxy.$eventBus.emit('onSocketConnect');
      });
    })
  } else {
    socket_connect().then(async res => {
      // 初始化
      $socket.init({
        app_key: res.app_key,
        serverUrl: new URL(res.server_url)
      });
  
      // 连接socket
      await $socket.connect().then(res => {
        proxy.$eventBus.emit('onSocketConnect');
      });
    })
  }

  console.log('App.vue mounted')
})

onUnmounted(() => {
  $socket && $socket.disconnect();
  localStorage.removeItem('subscribed_channel'); // 清除存储的频道列表
})

</script>

<template>
  <a-config-provider :locale="locale">
    <!-- 登录页布局 -->
    <div v-if="isLoginPage" class="login-layout">
      <router-view />
    </div>

    <!-- 主应用布局 -->
    <div v-else class="layout">
      <SiderMenu />
      <section class="main">
        <HeaderNav />
        <main class="content">
          <router-view />
        </main>
      </section>
    </div>
  </a-config-provider>
</template>

<style scoped>
.login-layout {
  min-height: 100vh;
}

.layout {
  display: flex;
  min-height: 100vh;
  background: #f5f6f7;
  color: #333;
}

.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.content {
  padding: 16px;
  flex: 1;
  height: 0;
}
</style>

<style>
/* ========== 全局滚动条样式 ========== */
/* 滚动条整体宽度 */
::-webkit-scrollbar {
  width: 6px;
  /* 垂直滚动条宽度 */
  height: 6px;
  /* 水平滚动条高度 */
}

/* 滚动条轨道（背景） */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* 轨道背景色 */
  border-radius: 3px;
  /* 轨道圆角 */
}

/* 滚动条滑块（可拖动部分） */
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  /* 滑块默认颜色 */
  border-radius: 3px;
  /* 滑块圆角 */
  transition: background 0.3s ease;
  /* 平滑过渡 */
}

/* 滚动条滑块 hover 状态 */
::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
  /* 滑块 hover 颜色 */
}

/* 滚动条滑块 active 状态（按下时） */
::-webkit-scrollbar-thumb:active {
  background: #888;
  /* 滑块按下颜色 */
}

/* 滚动条两端按钮（极少使用，可隐藏） */
::-webkit-scrollbar-button {
  display: none;
  /* 隐藏上下箭头按钮 */
}

/* 滚动条角落（水平+垂直滚动条交汇处） */
::-webkit-scrollbar-corner {
  background: transparent;
  /* 透明处理 */
}
</style>